export const safe = (fn, expectedType='string', fallbackValue='-') => {
  try {
    const result = fn();
    if (expectedType === 'object') {
      if (result !== null && typeof result === 'object' && Object.prototype.toString.call(result) === '[object Object]') {
        return result;
      } else {
        //console.log(`Expected type "${expectedType}" but received type "${Object.prototype.toString.call(result)}" for function: ${fn.toString()}`);
        return fallbackValue;
      }
    }
    if (typeof result !== expectedType) {
      //console.log(`Expected type "${expectedType}" but received type "${typeof result}" for function: ${fn.toString()}`);
      return fallbackValue;
    }
    return result;
  } catch (err) {
    //console.log("safe() failed:", fn.toString(), "| Error:", err.message);
    return fallbackValue; 
  }
};